import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { LifecycleStage } from '@/types/platform';

const STYLES: Record<LifecycleStage, string> = {
  new: 'border-slate-500/30 bg-slate-500/10 text-slate-400',
  activated: 'border-blue-500/30 bg-blue-500/10 text-blue-400',
  active: 'border-status-allow/30 bg-status-allow/10 text-status-allow',
  dormant: 'border-status-warning/30 bg-status-warning/10 text-status-warning',
  paying: 'border-indigo-500/30 bg-indigo-500/10 text-indigo-400',
  churned: 'border-status-deny/30 bg-status-deny/10 text-status-deny',
};

export function LifecycleBadge({ stage }: { stage: LifecycleStage }) {
  return (
    <Badge variant="outline" className={cn('capitalize', STYLES[stage] ?? STYLES.new)}>
      {stage}
    </Badge>
  );
}
